var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgLoginTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 272,
    viewBox: "0 0 1920 272",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1776.97 271.033V199.013L1848.48 128V199.013L1776.97 271.033Z",
    fill: "#FEB449"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1848.48 271.033V199.013L1920 128V199.013L1848.48 271.033Z",
    fill: "#FEB449"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M366.872 38.9456C351.799 46.8082 303.409 27.8575 298.515 -16.2579C326.179 -24.4117 364.812 7.56015 366.872 38.9456Z",
    fill: "#DE421E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M334.879 -60.7405C321.288 -61.6737 291.845 -32.2242 302.416 1.73601C325.344 -1.15969 343.443 -37.0362 334.879 -60.7405Z",
    fill: "#DE421E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M240.964 64.0095C259.078 70.4878 310.384 41.7486 309.036 -8.45996C276.763 -13.3139 238.412 28.5094 240.964 64.0095Z",
    fill: "#DE421E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M229.551 -39.7866C241.982 -51.5004 293.941 -46.3731 310.705 -5.05028C286.178 10.3791 240.103 -10.0002 229.551 -39.7866Z",
    fill: "#DE421E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgLoginTop);
export default __webpack_public_path__ + "static/media/bg_login_top.62383300c4ae2e0d8a1018b564dbde6e.svg";
export { ForwardRef as ReactComponent };